import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEvaluacionesAction,
  deleteEvaluacionesAction,
  setActivoEvaluacionesAction,
} from '../EvaluacionesAction';
import { PARAMS_EVALUACIONES } from '../EvaluacionesReducer';

const ListadoEvaluaciones = ({ isDelete = false, setIsDelete = () => {} }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const evaluacionesStore = Redux.useSelector((state) => state.evaluaciones);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {};

      dispatch({ type: PARAMS_EVALUACIONES, payload });
      if (evaluacionesStore.all && evaluacionesStore.all.length === 0) {
        await allEvaluacionesAction(dispatch, {
          ...evaluacionesStore.params,
          ...payload,
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    setIsDelete(false);
    const data = evaluacionesStore.all.find((el) => el.id === id);
    await setActivoEvaluacionesAction(dispatch, data);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteEvaluacionesAction(
      { dispatch, notify },
      evaluacionesStore.activo.id,
      evaluacionesStore.params,
    );
    setLoadingDelete(false);
    setActivoEvaluacionesAction(dispatch, null);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" alignItems="center">
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value}
              </NameComponent>
              {evaluacionesStore.activo?.id === tableMeta.rowData[0] &&
                !isDelete && (
                  <Chip label="Editando" size="small" color="info" />
                )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.desc.name,
      label: CONST.desc.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" sx={{ width: '60px' }}>
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  setIsDelete(true);
                  const data = evaluacionesStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoEvaluacionesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    reponsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={evaluacionesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={evaluacionesStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {evaluacionesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {evaluacionesStore.activo.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEvaluaciones;
